/**
 * Repertoire state slice
 */
export const repertoireSlice = {
    latestMoves: [],
    isLoading: false,
    error: null,
    status: null, // { inRepertoire, noRepertoire, successCount, nextMoves, message }
    fen: null, // position `status` and `latestMoves` belong to
    hintMode: null, // null | "hint" | "move" — controls board shape overlay
};
